import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { MetaMaskProvider } from './context/MetaMaskContext';
import { Toaster } from 'react-hot-toast';
import reportWebVitals from './reportWebVitals';
import BaseService from './services/base.service';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';

BaseService.setApiBase(process.env.REACT_APP_BASE_API as string);

ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
      <MetaMaskProvider>
        <Toaster position="top-center" />
        <App />
      </MetaMaskProvider>
    </Provider>,
  // </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
